import { supabase } from './supabase';

export interface Profile {
  id: string;
  username: string;
  email: string;
  artist_types: string[];
  bio?: string;
  location?: string;
  instagram_url?: string;
  spotify_url?: string;
  tiktok_url?: string;
  soundcloud_url?: string;
  cover_image?: string;
  avatar_url?: string;
  created_at: string;
}

export async function getProfile(userId: string): Promise<Profile | null> {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single();

  if (error) {
    console.error('Error fetching profile:', error);
    return null;
  }

  return data;
}

export async function updateProfile(userId: string, updates: Partial<Profile>) {
  const { data, error } = await supabase
    .from('profiles')
    .update(updates)
    .eq('id', userId)
    .select()
    .single();

  if (error) {
    console.error('Error updating profile:', error);
    throw error;
  }

  return data;
}

export async function uploadProfileImage(
  userId: string, 
  file: File, 
  type: 'avatar' | 'cover'
): Promise<string> {
  const fileExt = file.name.split('.').pop();
  const fileName = `${type}_${userId}.${fileExt}`;
  const filePath = `profiles/${userId}/${fileName}`;

  const { error: uploadError } = await supabase.storage
    .from('profile-images')
    .upload(filePath, file, { upsert: true });

  if (uploadError) {
    console.error('Error uploading image:', uploadError);
    throw uploadError;
  }

  const { data } = supabase.storage
    .from('profile-images')
    .getPublicUrl(filePath);

  const updates = type === 'avatar' 
    ? { avatar_url: data.publicUrl }
    : { cover_image: data.publicUrl };

  await updateProfile(userId, updates);

  return data.publicUrl;
}